import { Control } from "ol/control";

class Geoservicios extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const tipLabel = options.tipLabel ? options.tipLabel : "Geoservicios";

    const button = document.createElement("button");
    button.innerText = "Geoservicios";
    button.title = tipLabel;
    const element = document.createElement("div");
    element.className = "boton-geoservicios ol-unselectable ";
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    button.addEventListener("click", this.ayudaPage, false);
  }

  ayudaPage() {
    window.open("./geoservicios.html", "_blank");
  }
}
export default Geoservicios;
